import type { SensitivityAnalysisResult, SensitivityRoundResult } from '@aloft/toolkit-shared';
import { AloftPrice, orUndefined } from '@aloft/toolkit-shared';

/**
 * Resolves the unit rate that should be treated as "selected" for the Sensitivity Analysis
 * Modal's chart star marker (SensitivityModalGraphSection.tsx) and comp-table row
 * highlighting (SensitivityRateSection.tsx).
 */
export const resolveSensitivitySelectedRate = (
  selectedRound?: SensitivityRoundResult,
  sensitivityResult?: SensitivityAnalysisResult,
): AloftPrice | undefined =>
  orUndefined(AloftPrice.fromDollarLike)(selectedRound?.optimalRate) ??
  orUndefined(AloftPrice.schema.parse)(sensitivityResult?.selectedRate.rate);
